import { Radio, UserX, UserPlus, PhoneOff, ShieldOff, Users, GraduationCap } from 'lucide-react';

/* ─── Painel Urgente — Foco em Responsaveis (acao politica) ─── */

export function PainelAlertaUrgente({ data, familias }: { data: any; familias: any }) {
  const semConta = familias?.semConta || 0;
  const pendentes = familias?.comContaPendente || 0;
  const semResp = familias?.totalAlunosSemResponsavel || 0;
  const semNotif = Math.max(0, (familias?.totalResponsaveis || 0) - (familias?.recebemNotificacao || 0));
  const taxaAtivacao = familias?.taxaAtivacao || 0;

  const alertasCriticos = data?.alertas?.criticos || [];
  const alunosRisco = data?.analitico?.alunosRisco?.length || alertasCriticos.filter((a: any) => a.tipoIncidente === 'AUSENCIA_PROLONGADA').length || 0;

  const items = [
    { label: 'Risco de evasao', valor: alunosRisco, icon: GraduationCap, cor: alunosRisco > 0 ? '#dc2626' : '#10b981' },
    { label: 'Alunos sem responsavel', valor: semResp, icon: ShieldOff, cor: semResp > 0 ? '#dc2626' : '#10b981' },
    { label: 'Responsaveis sem conta', valor: semConta, icon: UserX, cor: semConta > 0 ? '#dc2626' : '#10b981' },
    { label: 'Ativacao pendente', valor: pendentes, icon: UserPlus, cor: pendentes > 0 ? '#d97706' : '#10b981' },
    { label: 'Sem receber alertas', valor: semNotif, icon: PhoneOff, cor: semNotif > 0 ? '#d97706' : '#10b981' },
  ];

  const totalPendencias = semConta + pendentes + semResp + semNotif + alunosRisco;
  const temProblema = totalPendencias > 0;

  return (
    <div className={`muni-painel-urgente ${temProblema ? 'has-critico' : 'all-ok'}`}>
      <div className="muni-painel-urgente-header">
        <div className={`muni-painel-urgente-pulse ${temProblema ? 'red' : 'green'}`}>
          <Radio size={11} />
        </div>
        <span className="muni-painel-urgente-title">
          {temProblema ? 'FAMILIAS PRECISAM DE ACAO' : 'FAMILIAS CONECTADAS'}
        </span>
        <span className={`muni-painel-urgente-count ${temProblema ? 'red' : 'green'}`}>
          {totalPendencias}
        </span>
      </div>

      <div className="muni-painel-urgente-list">
        {items.map(item => (
          <div key={item.label}
            className={`muni-painel-urgente-item ${item.valor > 0 ? 'active' : ''}`}
            style={item.valor > 0 ? { color: item.cor } : undefined}>
            <item.icon size={12} />
            <span className="muni-painel-urgente-item-label">{item.label}</span>
            <strong className="muni-painel-urgente-item-val">{item.valor}</strong>
          </div>
        ))}
      </div>

      <div className="muni-painel-urgente-footer">
        <Users size={10} />
        <span>Ativacao: <strong style={{ color: taxaAtivacao >= 80 ? '#10b981' : '#d97706' }}>{taxaAtivacao}%</strong></span>
      </div>
    </div>
  );
}
